import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

function Terms() {
	return (
		<>
			<Helmet>
				<title>Terms of Service | Apex Specialty Contracting LLC</title>
				<meta name="description" content="Terms of Service for Apex Specialty Contracting LLC roofing and storm restoration services." />
			</Helmet>
			<PageHeader
				title="Terms of Service"
				subtitle="Last updated: January 1, 2025"
			/>
			<section className="section">
				<div className="container" style={{ maxWidth: 780 }}>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 8px' }}>Agreement to Terms</h3>
						<p className="helper" style={{ margin: 0 }}>
							By accessing <strong>appexconnecthub.com</strong> or contacting Apex Specialty Contracting LLC,
							you agree to these Terms of Service. If you do not agree, please do not use our website or services.
							These terms apply to all visitors, customers, and anyone who submits a service request.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Our Services</h3>
						<p className="helper" style={{ margin: 0 }}>
							Apex Specialty Contracting LLC provides residential and commercial roofing services including
							roof replacement, storm damage repair, insurance claims assistance, free inspections, gutter
							installation, and related specialty contracting. All work is performed by our licensed team
							(FL License #XXXXX2536) or supervised subcontractors carrying appropriate licensing and insurance.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Service Requests &amp; Estimates</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li>Submitting an estimate request does not constitute a contract or commitment to purchase services.</li>
							<li>Estimates are provided free of charge and are valid for 30 days unless otherwise stated.</li>
							<li>Actual pricing may vary based on on-site inspection findings, material costs, and scope of work.</li>
							<li>You agree to provide accurate information when submitting a request.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>SMS Communications</h3>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							By providing your phone number and checking the consent box on our contact form, you agree to
							receive SMS messages from Apex Specialty Contracting LLC regarding roofing estimates, appointment
							reminders, project updates, and promotional offers. Message frequency varies. Message and data
							rates may apply.
						</p>
						<p className="helper" style={{ margin: 0 }}>
							Reply <strong>STOP</strong> at any time to stop receiving messages.
							Reply <strong>HELP</strong> for help. Consent is not required to receive roofing services.
							See our <Link to="/sms-policy">SMS Policy</Link> for full details.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Acceptable Use</h3>
						<ul className="helper" style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
							<li>Do not submit false, fraudulent, or misleading information.</li>
							<li>Do not attempt to gain unauthorized access to our systems.</li>
							<li>Do not use our website or contact channels for spam, harassment, or unlawful purposes.</li>
							<li>Do not reproduce, copy, or distribute our website content without written permission.</li>
						</ul>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Warranties &amp; Liability</h3>
						<p className="helper" style={{ margin: '0 0 8px' }}>
							All roofing work comes with our standard 5-year workmanship warranty and applicable manufacturer
							material warranties. Details are provided in your written project contract.
						</p>
						<p className="helper" style={{ margin: 0 }}>
							This website is provided "as is." We are not liable for damages arising from reliance on
							website content beyond the scope of our written service contracts.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px', marginBottom: 20 }}>
						<h3 style={{ margin: '0 0 12px' }}>Governing Law</h3>
						<p className="helper" style={{ margin: 0 }}>
							These terms are governed by the laws of the State of Florida. Any disputes shall be resolved in
							Pinellas County, Florida.
						</p>
					</div>

					<div className="card" style={{ padding: '24px 28px' }}>
						<h3 style={{ margin: '0 0 8px' }}>Contact</h3>
						<p className="helper" style={{ margin: 0 }}>
							Questions about these terms? Contact us:<br />
							<strong>APEX SPECIALTY CONTRACTING LLC</strong><br />
							183 Highland Rd, Tarpon Springs, FL 34689<br />
							Phone: <a href="tel:+19163160696">(916) 316-0696</a><br />
							Email: <a href="mailto:info@appexconnecthub.com">info@appexconnecthub.com</a>
						</p>
					</div>

				</div>
			</section>
		</>
	);
}

export default Terms;



